import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-visa",
  templateUrl: "./visa.component.html",
  styleUrls: ["./visa.component.scss"],
})
export class VisaComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
